import { AddCourseForm } from "@/components/Materials/Forms/AddCourseForm";
import { Modal } from "@/ui";

interface AddCourseModalProps {
  show: boolean;
  onClose: () => void;
}

export const AddCourseModal = ({ show, onClose }: AddCourseModalProps) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      title="Add Course"
      description="Create a new course"
    >
      <AddCourseForm onClose={onClose} />
    </Modal>
  );
};
